var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 6.66663C7.03551 6.66663 7.33398 6.9651 7.33398 7.33329V11.3333C7.33398 11.7015 7.03551 12 6.66732 12C6.29913 12 6.00065 11.7015 6.00065 11.3333V7.33329C6.00065 6.9651 6.29913 6.66663 6.66732 6.66663Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 11.3333V7.33329C10.0007 6.9651 9.70218 6.66663 9.33398 6.66663C8.96579 6.66663 8.66732 6.9651 8.66732 7.33329V11.3333C8.66732 11.7015 8.96579 12 9.33398 12C9.70218 12 10.0007 11.7015 10.0007 11.3333Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66732 3.33329V2.66663C4.66732 2.13619 4.87803 1.62748 5.2531 1.25241C5.62818 0.87734 6.13688 0.666626 6.66732 0.666626H9.33398C9.86442 0.666626 10.3731 0.87734 10.7482 1.25241C11.1233 1.62748 11.334 2.13619 11.334 2.66663V3.33329H14.0007C14.3688 3.33329 14.6673 3.63177 14.6673 3.99996C14.6673 4.36815 14.3688 4.66663 14.0007 4.66663H13.334V13.3333C13.334 13.8637 13.1233 14.3724 12.7482 14.7475C12.3731 15.1226 11.8644 15.3333 11.334 15.3333H4.66732C4.13688 15.3333 3.62818 15.1226 3.2531 14.7475C2.87803 14.3724 2.66732 13.8637 2.66732 13.3333V4.66663H2.00065C1.63246 4.66663 1.33398 4.36815 1.33398 3.99996C1.33398 3.63177 1.63246 3.33329 2.00065 3.33329H4.66732ZM6.19591 2.19522C6.32094 2.0702 6.49051 1.99996 6.66732 1.99996H9.33398C9.5108 1.99996 9.68036 2.0702 9.80539 2.19522C9.93041 2.32025 10.0007 2.48982 10.0007 2.66663V3.33329H6.00065V2.66663C6.00065 2.48982 6.07089 2.32025 6.19591 2.19522ZM4.00065 4.66663V13.3333C4.00065 13.5101 4.07089 13.6797 4.19591 13.8047C4.32094 13.9297 4.49051 14 4.66732 14H11.334C11.5108 14 11.6804 13.9297 11.8054 13.8047C11.9304 13.6797 12.0007 13.5101 12.0007 13.3333V4.66663H4.00065Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.bc7b2abbdc759d2d8258989506af8293.svg";
export { ForwardRef as ReactComponent };